export default "/assets/website/images/bg.jpg?8547ff96a5151942a0193a922a071a4c";